module.exports = __webpack_public_path__ + "static/media/maximize.52bd8411.svg";